import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    DefaultDataServiceConfig, EntityActionFactory, EntityCollectionReducerMethodsFactory,
    EntityDataModule, EntityDataService,
    EntityDispatcherDefaultOptions,
    PersistenceResultHandler
} from '@ngrx/data';
import { PersonMessageEntityDataService, PersonMessageService } from '../../message-list/person-message.service';
import { patientMessageEntityMetadata } from '../../message-list/state/message.entity';
import { missedAppointmentsDashboardEntityMetadata } from '../../modules/dashboard/missed-appointments-widget/state/missed-appointments-dashboard.entity';
import {
    MissedAppointmentsDashboardEntityDataService,
    MissedAppointmentsDashboardService
} from '../../modules/dashboard/missed-appointments-widget/state/missed-appointments-dashboard.service';
import { recallsDashboardEntityMetadata } from '../../modules/dashboard/recalls-widget/state/recalls-dashboard.entity';
import {
    RecallsDashboardEntityDataService,
    RecallsDashboardService
} from '../../modules/dashboard/recalls-widget/state/recalls-dashboard.service';
import { appointmentListEntityMetadata } from '../../reminders/appointment-list/state/appointment-list.entity';
import {
    AppointmentListEntityDataService,
    AppointmentListService
} from '../../reminders/appointment-list/state/appointment-list.service';
import { remindersReportEntityMetadata } from '../../reminders/appointment-list/state/reminders-report.entity';
import {
    RemindersReportEntityDataService,
    RemindersReportService
} from '../../reminders/appointment-list/state/reminders-report.service';
import { dateAppointmentEntityMetadata } from '../../reminders/appointments/state/date-appointment.entity';
import {
    DateAppointmentEntityDataService,
    DateAppointmentService
} from '../../reminders/appointments/state/date-appointment.service';
import { patientAppointmentEntityMetadata } from '../../reminders/patients/state/patient-appointment.entity';
import {
    PatientAppointmentEntityDataService,
    PatientAppointmentService
} from '../../reminders/patients/state/patient-appointment.service';
import { entityConfig, entityDataServiceConfig, entityDispatcherDefaultOptions } from './entity.config';
import { WebSocketEntityCollectionReducerMethodsFactory } from './web-socket-entity-collection-reducer-methods';
import { WebSocketPersistenceResultHandler } from './web-socket-persistence-result-handler';

@NgModule({
    imports: [
        CommonModule,
        EntityDataModule.forRoot(entityConfig)
    ],
    providers: [
        {
            provide: DefaultDataServiceConfig,
            useValue: entityDataServiceConfig
        },
        PersonMessageEntityDataService,
        PersonMessageService,
        DateAppointmentEntityDataService,
        DateAppointmentService,
        PatientAppointmentEntityDataService,
        PatientAppointmentService,
        AppointmentListService,
        AppointmentListEntityDataService,
        RemindersReportService,
        RemindersReportEntityDataService,
        RecallsDashboardService,
        RecallsDashboardEntityDataService,
        MissedAppointmentsDashboardService,
        MissedAppointmentsDashboardEntityDataService,
        {
            provide: PersistenceResultHandler,
            useClass: WebSocketPersistenceResultHandler },
        {
            provide: EntityCollectionReducerMethodsFactory,
            useClass: WebSocketEntityCollectionReducerMethodsFactory
        },
        {
            provide: EntityDispatcherDefaultOptions,
            useValue: entityDispatcherDefaultOptions
        }
        ]
})
export class EntityModule {
    constructor(entityDataService: EntityDataService,
                private personMessageEntityDataService: PersonMessageEntityDataService,
                private dateAppointmentEntityDataService: DateAppointmentEntityDataService,
                private patientAppointmentEntityDataService: PatientAppointmentEntityDataService,
                private appointmentListEntityDataService: AppointmentListEntityDataService,
                private remindersReportEntityDataService: RemindersReportEntityDataService,
                private recallsDashboardEntityDataService: RecallsDashboardEntityDataService,
                private missedDashboardEntityDataService: MissedAppointmentsDashboardEntityDataService
    ) {
        entityDataService.registerService(patientMessageEntityMetadata.entityName, personMessageEntityDataService);
        entityDataService.registerService(dateAppointmentEntityMetadata.entityName, dateAppointmentEntityDataService);
        entityDataService.registerService(patientAppointmentEntityMetadata.entityName, patientAppointmentEntityDataService);
        entityDataService.registerService(appointmentListEntityMetadata.entityName, appointmentListEntityDataService);
        entityDataService.registerService(remindersReportEntityMetadata.entityName, remindersReportEntityDataService);
        entityDataService.registerService(recallsDashboardEntityMetadata.entityName, recallsDashboardEntityDataService);
        entityDataService.registerService(missedAppointmentsDashboardEntityMetadata.entityName, missedDashboardEntityDataService);
    }
}
